<template>
  <div class="form-item-texarea">
    <label :for="element.metadata?.key">{{ element.metadata?.title }}</label>
    <textarea
      :id="element.metadata?.key"
      :required="element.metadata?.required ?? false"
      :name="element.metadata?.key"
      type="text"
      rows="5"
      :value="prefill"
    />
  </div>
</template>
<script setup lang="ts">
import { type WebformElementTextareaFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

const props = defineProps<{
  element: WebformElementTextareaFragment
  formErrors: WebformSubmissionValidationErrorFragment[]
  prefilledInputs: InputPrefill[]
}>()

const { prefill } = useInputPrefill(props.prefilledInputs, props.element)

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.form-item-texarea {
  @include tools.form-group-text;
}
</style>
